const getAttributeName = (column) => {
  if (column?.name) {
    switch (column.name) {
      case 'prioritizedId':
        return 'displayId';
      case 'client':
        return 'client.name';
      case 'site':
        return 'site.name';
      case 'requester':
        return 'requester.name';
      case 'technician':
        return 'technician.name';
      case 'techGroup':
        return 'techGroup.name';
      case 'firstResponseTimer':
        return 'firstResponseDueTime';
      case 'resolutionTimer':
        return 'resolutionDueTime';
      case 'sla':
        return 'sla.name';
      default:
        return column.name;
    }
  }
  return '';
};

const getCommonPinningStyles = (column) => {
  const isPinned = column.getIsPinned();

  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned && 'sticky',
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0
  };
};

export { getAttributeName, getCommonPinningStyles };
